import { userProfileApi } from "../../api/userProfileApi.js"

import { addNotification, notifyException, NotificationTypes } from "../actions/notificationActions.js"

import { userProfileSignal, userProfileLoadedSignal, userProfileErrorSignal } from "../signals/userProfileSignals.js"

export async function fetchUserProfile(userId, config, accessToken) {
    const f = "fetchUserProfile()"
    userProfileLoadedSignal.value = false
    userProfileSignal.value = null
    return await userProfileApi.fetchUserProfile(userId, config, accessToken).then(
        (userProfile) => {
            userProfileSignal.value = userProfile
            console.log(`${f}: fetched the following user profile:`)
            console.log(userProfile)
            userProfileLoadedSignal.value = true
            return userProfile
        }
    ).catch(
        (err) => {
            userProfileErrorSignal.value = err.message
            throw err
        }
    )
}

export const updateUserProfile = async (userId, userProfile, config, accessToken, reload=true) => {
    if (reload) {
        userProfileLoadedSignal.value = false
        userProfileSignal.value = null
    }
    return await userProfileApi.updateUserProfile(userId, userProfile, config, accessToken).then(
        (userProfile) => {
            if (reload) {
                userProfileSignal.value = userProfile
                userProfileErrorSignal.value = null
                userProfileLoadedSignal.value = true
            }
            return userProfile
        }
    ).catch(
        (err) => {
            userProfileErrorSignal.value = err
            throw err
        }
    )
}